import { createApi } from '@reduxjs/toolkit/query/react'
import { AxiosResponse } from 'axios'
import { IUser, TwigLoginResponse, UserPassPayload } from '../../interfaces/auth/IUser'
import { authAxiosQuery } from '../../utils/axios/auth.axios'
import { readFromStorage } from '../../utils/webStorage'
import { syncApiRegionFromAuthorizeResponse } from '../../config'

export const authApi = createApi({
    reducerPath: 'auth',
    baseQuery: authAxiosQuery(),
    endpoints: (builder) => ({
        login: builder.mutation<TwigLoginResponse, UserPassPayload>({
            query: (payload) => ({
                url: '/dom/login',
                method: 'POST',
                data: payload
            })
        }),
        authWithAgent: builder.mutation<{
            data: {
                chatData: any,
                metadata: { accessToken: string, refreshToken: string, user: any, isAdmin?: boolean }
            }
        }, { linkToken: string, chatData: any, dashboard?: string }>({
            query: (payload) => ({
                url: '/hotel-world-dom/activate-invited-user/chat',
                method: 'PUT',
                data: payload
            })
        }),
        signIn: builder.mutation<any, any>({
            query: (payload) => ({
                url: '/hotel-world-dom/hotel-admin/sign-in',
                method: 'PUT',
                data: payload
            })
        }),
        currentUser: builder.query<AxiosResponse<IUser>, {}>({
            query: (payload) => ({
                url: '/dom/authorize',
                method: 'POST',
                data: payload,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Authorization: `Bearer ${readFromStorage('accessToken')}`,
                },
            }),
            transformResponse: (response: AxiosResponse<IUser>) => {
                syncApiRegionFromAuthorizeResponse(response);
                return response;
            }
        }),
        demoRequest: builder.query<any, string>({
            query: (id) => ({
                url: `/demo-requests/${id}`,
                method: 'GET'
            }),
        }),
        refreshToken: builder.mutation<TwigLoginResponse, {}>({
            query: () => ({
                url: '/dom/refresh-token',
                method: 'POST',
                data: { token: readFromStorage('refreshToken') },
            })
        }),
        register: builder.mutation<any, any>({
            query: (payload) => ({
                url: '/rebecca-agent-dom.controller/register',
                method: 'POST',
                data: payload
            })
        }),
        signInWithAgent: builder.mutation<{
            data: {
                data: {
                    chatData: any,
                    chatId?: string,
                    metadata: { chatId: string, accessToken: string, refreshToken: string, user: any }
                }
            },
        }, {
            chatData: any,
            usedBefore?: boolean,
            dashboard?: string
        }>({
            query: (payload) => ({
                url: '/rebecca-agent-dom.controller/sign-in',
                method: 'POST',
                data: payload
            })
        }),
    }),
})

export const {
    useLoginMutation,
    useSignInMutation,
    useRegisterMutation,
    useDemoRequestQuery,
    useCurrentUserQuery,
    useRefreshTokenMutation,
    useAuthWithAgentMutation,
    useSignInWithAgentMutation
} = authApi
